export const Error:React.FC = ({children}) => {
    return <div className="text-xs bg-red-50 rounded-lg py-2 text-red-500 text-center flex items-center justify-center ">
        <div>{children}</div>
    </div>
}